/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Alert, Card, CardBody, Col, Media, Button, Form, FormGroup, Label, Input, Row, Container} from 'reactstrap';
import {Link, Redirect} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons';
import Footer from './footer/footer';
import LanguageManager from '../custom-classes/language-manager';
import ApiCalls from  '../custom-classes/api-calls';
import LoaderFullWindow from './loader-windows/loader-full-window';
import ModalGeneric from './modals/modal-generic';
import SessionManager from '../custom-classes/session-manager';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';

/**
 * The component (window) login
 */
class Login extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            username: "",
            password: "",
            usernameOrPasswordValid: true,
            loginError: false,
            loginErrorMessage: '',
            loading: false,
            showErrorModal: false,
            propsModal: null,
            isLoggedIn: false, // to manage the login
            navbarMobile: false
        };
        this.props.addTranslation(global);

        // handles the username change and password
        this.handleChangeUsername = this.handleChangeUsername.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.login = this.login.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);

        // Clear the session if any
        SessionManager.deleteSession();
    }

    /** To evaluate the correct menu navbar option **/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Call the web services to make the login
     */
    login() {
        if (this.state.username.length === 0 || this.state.password.length === 0) {
            this.setState({'usernameOrPasswordValid': false});
        }
        else {
            this.setState({loading: true});
            // Login
            ApiCalls.getLogin(this.state.username, this.state.password, (returned)=> {
                if (!returned.TransactionValid) {
                    let propsModal = {
                        bodyText: returned.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
                }
                else {
                    SessionManager.setSession(returned.Token);
                    this.setState({isLoggedIn: true})
                }

            });
        }
    }

    // Handles the username change
    handleChangeUsername(event) {
        this.setState({username: event.target.value}, () => {
            this.setState({usernameOrPasswordValid: (this.state.username.length > 0 && this.state.password.length > 0)});
        });
    }

    /**
     * Handles the password change, including a validation
     * @param event The event of changing it
     */
    handleChangePassword(event) {
        this.setState({password: event.target.value}, () => {
            this.setState({usernameOrPasswordValid: (this.state.username.length > 0 && this.state.password.length > 0)});
        });
    }

    /**
     * Toggles the alert modal
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }

    /**
     * Renders the generic modal used for messages
     * @returns {XML} Returns the component.
     */
    renderGenericModal() {
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Renders the login form
     * @returns {XML} Returns the XML of the component
     */
    renderForm() {
        return (
            <div>
                <Row className="text-center white-text">
                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}
                         className="text-center">
                        <h2 className="font-now-bold">
                            <FontAwesomeIcon className="fa-1x" icon={faSignInAlt}/> {' '}
                            <Translate id="login.welcome-back" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                    </Col>
                </Row>
                <Col sm={{size: 10, offset: 1}} md={{size: 10, offset: 1}} lg={{size: 8, offset: 2}}
                     className="margin-top-mandatory-25">
                    <Card>
                        <CardBody>
                            <Form>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Label for="username">
                                            <Translate id="login.username"/>
                                        </Label>
                                        <Input type="text" name="username" id="username"
                                               onChange={this.handleChangeUsername}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Label for="password">
                                            <Translate id="login.password"/>
                                        </Label>
                                        <Input type="password" name="password" id="password"
                                               onChange={this.handleChangePassword}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Alert color="danger" isOpen={!this.state.usernameOrPasswordValid}>
                                            <Translate id="login.username-password-required"/>
                                        </Alert>
                                        <Alert color="danger" isOpen={this.state.loginError}>
                                            <span>{this.state.loginErrorMessage}</span>
                                        </Alert>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Link color="link" to="/password-reset">
                                            <Translate id="login.forgot-password"/>
                                        </Link>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Button color="success" block onClick={this.login}
                                                disabled={!this.state.usernameOrPasswordValid}>
                                            <Translate id="login.log-in"/>
                                        </Button>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <Link className="btn btn-block btn-info" color="link" to="/subscribe">
                                            <Translate id="login.register"/>
                                        </Link>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{size: 10, offset: 1}}>
                                        <LanguageToggle/>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </div>
        )
    };

    /**
     * Renders the main form
     * @returns {XML} Returns the XML
     */
    render() {
        if (this.state.isLoggedIn === true)
            return (<Redirect to="/dashboard"/>);
        else {
            return (
                <div>
                    {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                    <div className="container-padding">
                        <Container className="margin-top-mandatory-60">
                            <Row>
                                {this.state.navbarMobile ?
                                    <Col xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                        <Media src={require('../img/user-icon-1.png')} alt="User icon" width="100%"/>
                                    </Col>
                                    : null }
                            </Row>
                            <Row>
                                <Col sm={{size: 10, offset: 1}} lg={{size: 8, offset: 2}} md={{size: 10, offset: 1}}>
                                    {this.renderForm()}
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                    <Media src={require('../img/logo-gs-a.png')} alt="Company logo"
                                           width="100%"/>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    {this.state.loading ? <LoaderFullWindow/> : null}
                    {this.state.showErrorModal ? this.renderGenericModal() : null}
                    <Footer/>
                </div>
            )
        }
    }
}

export default withLocalize(Login);